import { useCallback } from "react";
import _ from "lodash";
import {
  _ACTIONS,
  _HEADERS_NAME_INPUT_SALES,
  _HTTP,
  _MESSAGES,
  _SWAL_ICONS,
} from "../../../utils/constants";
import { _ROUTES } from "../../../utils/_routes_constants";
import { buildIRI } from "../../../utils/function";
import { RequestHelper } from "../../../utils/requestHelper";
import { createToast } from "../../../utils/toast";

export const HandleValueCell = ({
  params,
  priceId,
  columnsId,
  valuesForVolumes,
  setRefreshData,
  rows,
  setRows,
}) => {
  const requestHelper = new RequestHelper();

  const handleCellValueChanged = useCallback(async (agParams) => {
    const { colDef, data, newValue, node } = agParams;
    const { field } = colDef;

    // Mettre à jour rows avec la nouvelle valeur pour que computedRows recalcule
    const updatedRows = rows.map((row) => {
      if (row.sale === data.sale && row.type === data.type) {
        if (field.startsWith("months.")) {
          const month = field.replace("months.", "");
          return {
            ...row,
            months: { ...row.months, [month]: parseFloat(newValue) || 0 },
          };
        } else if (field === "cash" || field === "credit" || field === "discount") {
          return { ...row, [field]: parseFloat(newValue) || 0 };
        }
      }
      return row;
    });
    setRows(updatedRows);
    const { headerName } = colDef;

    const month = parseInt(field.replace("months.", ""));
    const bdVolume = data.bdVolume;
    const bdPrice = data.bdPrice;

    let payload = {};
    if (
      headerName === _HEADERS_NAME_INPUT_SALES.CASH ||
      headerName === _HEADERS_NAME_INPUT_SALES.CREDIT ||
      headerName === _HEADERS_NAME_INPUT_SALES.DISCOUNT
    ) {
      payload = {
        fiscalYear: params.fiscalYear,
        version: params.version || 1,
        site: buildIRI("/sites", data.siteId),
        [bdPrice]: parseFloat(newValue) || 0,
      };
    } else {
      payload = {
        fiscalMonth: month,
        fiscalYear: params.fiscalYear,
        version: params.version || 1,
        site: buildIRI("/sites", data.siteId),
        [bdVolume]: parseFloat(newValue) || 0,
      };
    }
    if (
      headerName === _HEADERS_NAME_INPUT_SALES.CASH ||
      headerName === _HEADERS_NAME_INPUT_SALES.CREDIT ||
      headerName === _HEADERS_NAME_INPUT_SALES.DISCOUNT
    ) {
      payload.id = priceId.current;
    } else {
      if (!_.isUndefined(columnsId.current[month])) {
        payload.id = columnsId.current[month];
      }
    }

    const method = payload.id ? _ACTIONS.PATCH : _ACTIONS.POST;
    const url =
      headerName === _HEADERS_NAME_INPUT_SALES.CASH ||
      headerName === _HEADERS_NAME_INPUT_SALES.CREDIT ||
      headerName === _HEADERS_NAME_INPUT_SALES.DISCOUNT
        ? payload.id
          ? `${_ROUTES.IPT_SALE_AGG_PRICES}/${payload.id}`
          : _ROUTES.IPT_SALE_AGG_PRICES
        : payload.id
        ? `${_ROUTES.IPT_SALE_AGG_MONTHS}/${payload.id}`
        : _ROUTES.IPT_SALE_AGG_MONTHS;

    requestHelper
      .doRequest(method, url, payload)
      .then((res) => {
        if (res.status === _HTTP.created || res.status === _HTTP.ok) {
          createToast(_SWAL_ICONS.success, "Input sale agg saved successfully");
          if (method === _ACTIONS.POST && res.data?.id) {
            if (
              headerName === _HEADERS_NAME_INPUT_SALES.CASH ||
              headerName === _HEADERS_NAME_INPUT_SALES.CREDIT ||
              headerName === _HEADERS_NAME_INPUT_SALES.DISCOUNT
            ) {
              priceId.current = res.data.id;
            } else {
              const updatedData = {
                ...data,
                inputsId: {
                  ...data.inputsId,
                  [month]: res.data.id,
                },
                cash: data.cash,
              };
              node.setData(updatedData);
              columnsId.current[month] = res.data.id;
            }
          }
          if (
            headerName !== _HEADERS_NAME_INPUT_SALES.CASH &&
            headerName !== _HEADERS_NAME_INPUT_SALES.CREDIT &&
            headerName !== _HEADERS_NAME_INPUT_SALES.DISCOUNT
          ) {
            valuesForVolumes.current.push({
              id: res.data.id,
              month: month,
              type: data.type,
            });
          }
          setRefreshData((prev) => !prev);
        }
      })
      .catch(() => {
        createToast(_SWAL_ICONS.error, _MESSAGES.error);
      });
  }, [rows, setRows]);

  return handleCellValueChanged;
};
